<template>
  <v-dialog :value="true" width="1000" @click:outside="$emit('closeInfrastructureDialog')">
    <EsCard>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-card-subtitle>Select Infrastructure Category</v-card-subtitle>
              <v-radio-group row v-model="infrastructureCategory">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="3" v-for="category in filteredCategories" :key="category.label">
                      <v-radio :label="category.label" :value="category"></v-radio>
                    </v-col>
                  </v-row>
                </v-container>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <EsButtonAction @click="$emit('closeInfrastructureDialog')" label="Cancel"/>
          <EsButtonSave :disabled="infrastructureCategory == null" label="Select" @click="selectInfrastructure()"/>
        </v-card-actions>
      </v-card-text>
    </EsCard>
  </v-dialog>
</template>

<script>
import { EsCard, EsButtonAction, EsButtonSave } from '@86-repairs/design-system';

export default {
  name: 'EsInfrastructurePicker',
  props: {
    location: Object,
    allAssetTypes: {
      type: Array,
      default: () => [],
    },
    allServiceCategories: {
      type: Array,
      default: () => [],
    },
    infrastructureOptions: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    EsCard,
    EsButtonAction,
    EsButtonSave,
  },
  data: () => ({
    infrastructureCategory: undefined,
    infrastructure: [],
    infrastructureDescription: null,
  }),
  computed: {
    filteredCategories() {
      return this.allAssetTypes
        ?.filter((type) => type.isInfrastructure === true)
        .map((type) => {
          const asset = this.infrastructureOptions.find((e) => e.assetTypeId === type.id);
          return asset ? {
            label: this.getServiceCategoryName(type.serviceCategoryId),
            asset,
          } : null;
        })
        .filter((c) => c != null)
        .sort((a, b) => a.label > b.label ? 1 : -1);
    },
  },
  methods: {
    selectInfrastructure() {
      this.$emit('assetSelected', this.infrastructureCategory.asset);
      this.$emit('closeInfrastructureDialog');
    },
    getServiceCategoryName(id) {
      return this.allServiceCategories.find((c) => c.id === id)?.name;
    },
  },
};
</script>
